<template>
  <standard-layout v-if="betPeriod">
    <template v-slot:fixed-top>
      <!-- mobile-only: Fixed-Top Header mit Ergebnis, falls BetPeriod läuft und Tippschein vorhanden -->
      <div v-if="betSlip && pointsAvailable && betSlip.id"
           class="d-block text-center fixed-top border-bottom border-light d-md-none"
           :class="{'bg-dark text-light': betPeriod.finished, 'bg-sakali-primary': betPeriod.running}">
        Punkte: {{ betSlip.points | float }}&nbsp;|&nbsp;{{ betSlip.payOff | kies }} | {{ betSlip.rankPercentage }}%
        sind
        schlechter
      </div>
    </template>
    <template v-slot:heading>
      <!-- Header mit Navigation -->
      <div class="row justify-content-between mt-md-0"
           :class="{'mt-5': pointsAvailable && betSlip}">
        <div class="col">
          <sakali-header :title="betPeriodTimeframe"
                         :super-title="'Tippschein ' + betPeriod.number + ' vom'"/>
        </div>
        <div class="col text-end my-auto">
          <router-link tag="span"
                       v-if="betPeriod.number > 1"
                       class="link hover-sakali-primary"
                       :to="{name:'bet',replace: true, params: {betPeriodNumber: bpNumberNumber -1}}"
                       :replace="true">
            <fas icon="chevron-left"
                 size="lg"
                 class="me-3">
            </fas>
          </router-link>
          <router-link tag="span"
                       class="link hover-sakali-primary"
                       v-if="betPeriod.hasNext"
                       :to="{name:'bet',replace: true, params: {betPeriodNumber: bpNumberNumber +1}}"
                       :replace="true">
            <fas icon="chevron-right"
                 size="lg"
                 class="me-3"
                 :class="{'muted':!betPeriod.previousBetPeriodId > 0}">
            </fas>
          </router-link>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <bet-slip
          :bet-period="betPeriod"
          @betSlip="betSlip = $event"/>
    </template>
    <template v-slot:right1>
      <better-of-the-week
          v-if="pointsAvailable"
          :bet-period-id="betPeriod.id"/>
      <bet-slip-ranking
          v-if="pointsAvailable"
          :betPeriod="betPeriod"
          class="mt-2"/>
      <bet-kings
          v-if="pointsAvailable"
          :bet-period-number="betPeriod.number"
          :live="betPeriod.running"/>
      <real-challenge-ranking
          v-if="!pointsAvailable"
          :challenge-infos="betPeriodChallenges"/>
    </template>
  </standard-layout>
</template>

<script>
import sakaliApi from "../sakali-api";
import {mapActions} from 'vuex'
import moment from "moment";

import BetSlip from '@/components/bets/BetSlip'
import BetterOfTheWeek from "@/components/bets/BetterOfTheWeek";
import BetKings from "@/components/bets/BetKings";
import RealChallengeRanking from '@/components/bets/RealChallengeRanking'
import BetSlipRanking from "@/components/bets/BetSlipRanking";
import StandardLayout from "@/layouts/StandardLayout"

export default {
  props: {
    betPeriodNumber: [String, Number]
  },
  data() {
    return {
      betPeriod: null,
      betSlip: null
    }
  },
  computed: {
    betPeriodTimeframe() {
      return moment(new Date(this.betPeriod.start)).format('DD.MM.') + '-'
          + moment(new Date(this.betPeriod.matchEndDate)).format('DD.MM.');
    },
    pointsAvailable() {
      return this.betPeriod && (this.betPeriod.running || this.betPeriod.finished)
    },
    betPeriodChallenges() {
      let res = [];
      this.betPeriod.realMatches.forEach(rm => {
        if (!rm.koMode && res.map(ci => ci.challenge).indexOf(rm.challenge) === -1)
          res.push({
            challenge: rm.challenge,
            round: rm.round,
            year: moment(rm.start).year()
          })
      })
      return res;
    },
    bpNumberNumber() {
      return parseInt(this.betPeriodNumber)
    }
  },
  methods: {
    ...mapActions(['messageAction', 'handleErrorAction']),
    loadBetPeriod() {
      let bpNumber = this.betPeriodNumber
      if (!bpNumber) {
        sakaliApi.get('/betperiods/current-number')
            .then(n => {
              this.$router.push({name: 'bet', params: {betPeriodNumber: n.data}})
            })
            .catch(err => this.handleError(err))
      } else {
        const url = '/betperiods/by-number/' + bpNumber;
        sakaliApi.get(url)
            .then(response => {
              this.betPeriod = response.data
            })
            .catch(error => {
              this.handleErrorAction(error)
            })
      }
    }
  },
  watch: {
    betPeriodNumber: {
      handler() {
        this.loadBetPeriod()
      },
      immediate: true
    }
  },
  components: {
    BetSlip, BetterOfTheWeek, BetKings, RealChallengeRanking, BetSlipRanking, StandardLayout
  }
}
</script>
